import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import {
  $upgradePlanModalState,
  closeModal,
} from './UpgradePlanModal.duck';
import { injectIntl } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';

import {
  Modal,
  PrimaryButton,
} from '../../components';

import css from './UpgradePlanModal.module.scss';

const UpgradePlanModalComp = (props) => {
  const {
    history,
    upgradePlanModalState,
    onClose,
  } = props;

  const handleClick = () => {
    onClose();
    history.push(createResourceLocatorString(
      'AirPricingPage',
      routeConfiguration(),
      {},
      {}
    ));
  };

  return (
    <Modal
      id="UpgradePlanModal"
      isOpen={upgradePlanModalState.isOpen}
      onClose={onClose}
      usePortal={false}
      onManageDisableScrolling={() => {}}
    >
      <div className={css.root}>
        <p>
          In order to create more listings, please upgrade your plan.
        </p>
        <PrimaryButton
          className={css.button}
          onClick={handleClick}
        >
          UPGRADE
        </PrimaryButton>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    upgradePlanModalState: $upgradePlanModalState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onClose: () => dispatch(closeModal()),
  };
};

const UpgradePlanModal = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(UpgradePlanModalComp);

export default UpgradePlanModal;
